import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconFaceSmile, IconSend } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import Input from '../../../base/ui/components/web/Input';
import { areSmileysDisabled } from '../../functions';
import SmileysPanel from './SmileysPanel';
//@ts-ignore
import ChatFileBox from './ChatFileBox';
import { IconButton } from '@mui/material';
// import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
/**
 * Implements a React Component for drafting and submitting a chat message.
 *
 * @augments Component
 */
class ChatInput extends Component {
    /**
     * Initializes a new {@code ChatInput} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            showSmileysPanel: false,
            uploadedFiles: [],
            fileSizeError: false,
            // files: [], Drag and Drop
            disabled: true
        };
        this._uploadFiles = () => {
            const { uploadedFiles } = this.state;
            uploadedFiles.forEach((file) => {
                if (file) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        let base64String = reader.result;
                        this.props.onSend(JSON.stringify({
                            oiriginalFile: {
                                lastModified: file?.lastModified,
                                name: file?.name,
                                size: file?.size,
                                type: file?.type,
                                webkitRelativePath: file?.webkitRelativePath
                            },
                            base64String: base64String.toString()
                        }));
                    };
                    reader.readAsDataURL(file);
                }
            });
            this.setState({ uploadedFiles: [] });
            this.setState({ disabled: true });
        };
        this._handleFileSelection = (event) => {
            const files = event.target.files;
            const fileSize = files[0]?.size;
            if (fileSize > 5000000) {
                this.setState({ fileSizeError: true });
            }
            else {
                this.setState({ fileSizeError: false });
                if (files) {
                    this.setState({ disabled: false });
                    this.setState({
                        uploadedFiles: [...this.state.uploadedFiles, ...files]
                    });
                }
            }
            event.target.value = null;
        };
        this._handleDropFile = (dropedFile) => {
            const file = dropedFile;
            const fileSize = file?.size;
            if (fileSize > 5000000) {
                this.setState({ fileSizeError: true });
            }
            else {
                this.setState({ fileSizeError: false });
                if (file) {
                    this.setState({ disabled: false });
                    this.setState({
                        uploadedFiles: [...this.state.uploadedFiles, file]
                    });
                }
            }
        };
        this.errorTimeout = null;
        this._textArea = React.createRef();
        // Bind event handlers so they are only bound once for every instance.
        this._onDetectSubmit = this._onDetectSubmit.bind(this);
        this._onMessageChange = this._onMessageChange.bind(this);
        this._onSmileySelect = this._onSmileySelect.bind(this);
        this._onSubmitMessage = this._onSubmitMessage.bind(this);
        this._toggleSmileysPanel = this._toggleSmileysPanel.bind(this);
        this._uploadFiles = this._uploadFiles.bind(this);
        this._handleFileSelection = this._handleFileSelection.bind(this);
        this.hideErrorMessage = this.hideErrorMessage.bind(this);
        this._handleDropFile = this._handleDropFile.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}.
     *
     * @inheritdoc
     */
    componentDidMount() {
        this.hideErrorMessage();
        if (isMobileBrowser()) {
            // Ensure textarea is not focused when opening chat on mobile browser.
            this._textArea?.current && this._textArea.current.blur();
        }
        else {
            this._focus();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.dropedFile !== this.props.dropedFile) {
            const file = this.props.dropedFile;
            this._handleDropFile(file);
        }
        if (prevState.fileSizeError !== this.state.fileSizeError) {
            this.hideErrorMessage();
        }
    }
    hideErrorMessage() {
        if (this.state.fileSizeError) {
            this.errorTimeout = setTimeout(() => {
                this.setState({ fileSizeError: false });
            }, 2000);
        }
        else {
            clearTimeout(this.errorTimeout);
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("div", { className: `chat-input-container${this.state.message.trim().length ? ' populated' : ''}`, style: {
                position: this.state.uploadedFiles.length > 0 ? "relative" : "unset",
            } },
            React.createElement("div", { style: { display: "grid",
                    gridTemplateColumns: "repeat(2,1fr)",
                    maxHeight: "123px",
                    borderRadius: "6px",
                    backgroundColor: "#c2c2c2",
                    marginBlockEnd: "3px",
                    overflowX: 'hidden',
                    overflowY: 'scroll'
                } },
                Array.isArray(this.state.uploadedFiles) && this.state.uploadedFiles.length > 0 ?
                    (this.state.uploadedFiles.map((file, index) => React.createElement(ChatFileBox, { file: file, handleDelete: () => this.setState({
                            uploadedFiles: this.state.uploadedFiles.filter((row, i) => i !== index),
                            disabled: this.state.uploadedFiles.length > 0 ? false : true
                        }), isBase64: false })))
                    : null,
                this.state.fileSizeError && (React.createElement("p", { style: {
                        color: "red",
                        width: "161%",
                        padding: "10px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        position: this.state.uploadedFiles.length > 0 ? "absolute" : "unset",
                        bottom: this.state.uploadedFiles.length > 0 ? "67px" : "",
                    } }, "File size exceeds 5MB. Please select a smaller file."))),
            React.createElement("div", { id: 'chat-input' },
                !this.props._areSmileysDisabled && this.state.showSmileysPanel && (React.createElement("div", { className: 'smiley-input' },
                    React.createElement("div", { className: 'smileys-panel' },
                        React.createElement(SmileysPanel, { onSmileySelect: this._onSmileySelect })))),
                React.createElement(Input, { className: 'chat-input', icon: this.props._areSmileysDisabled ? undefined : IconFaceSmile, iconClick: this._toggleSmileysPanel, maxRows: 5, onChange: this._onMessageChange, onKeyPress: this._onDetectSubmit, placeholder: this.props.t('chat.messagebox'), ref: this._textArea, textarea: true, value: this.state.message }),
                React.createElement(IconButton, { "aria-label": "upload picture", component: "label", sx: {
                        backgroundColor: "#c2c2c2!important",
                        borderRadius: "6px!important",
                        marginInlineEnd: "3px!important",
                        border: "0!important"
                    }, size: isMobileBrowser() ? 'large' : 'medium' },
                    React.createElement("input", { hidden: true, type: "file", size: 5000000, onChange: this._handleFileSelection, style: { display: "none" } }),
                    React.createElement(AttachFileIcon, null)),
                React.createElement(Button, { accessibilityLabel: this.props.t('chat.sendButton'), 
                    // disabled = { !this.state.message.trim() }
                    disabled: this.state.disabled, icon: IconSend, onClick: this._onSubmitMessage, size: isMobileBrowser() ? 'large' : 'medium' }))));
    }
    /**
     * Place cursor focus on this component's text area.
     *
     * @private
     * @returns {void}
     */
    _focus() {
        this._textArea?.current && this._textArea.current.focus();
    }
    /**
     * Submits the message to the chat window.
     *
     * @returns {void}
     */
    _onSubmitMessage() {
        const trimmed = this.state.message.trim();
        if (trimmed) {
            this.props.onSend(trimmed);
            this.setState({ disabled: true });
            this.setState({ message: '' });
            // Keep the textarea in focus when sending messages via submit button.
            this._focus();
        }
        if (Array.isArray(this.state.uploadedFiles) && this.state.uploadedFiles.length > 0)
            this._uploadFiles();
    }
    /**
     * Detects if enter has been pressed. If so, submit the message in the chat
     * window.
     *
     * @param {string} event - Keyboard event.
     * @private
     * @returns {void}
     */
    _onDetectSubmit(event) {
        // Composition events used to add accents to characters
        // despite their absence from standard US keyboards,
        // to build up logograms of many Asian languages
        // from their base components or categories and so on.
        if (event.isComposing || event.keyCode === 229) {
            // keyCode 229 means that user pressed some button,
            // but input method is still processing that.
            // This is a standard behavior for some input methods
            // like entering japanese or сhinese hieroglyphs.
            return;
        }
        if (event.key === 'Enter'
            && event.shiftKey === false
            && event.ctrlKey === false) {
            event.preventDefault();
            event.stopPropagation();
            this._onSubmitMessage();
        }
    }
    /**
     * Updates the known message the user is drafting.
     *
     * @param {string} value - Keyboard event.
     * @private
     * @returns {void}
     */
    _onMessageChange(value) {
        this.setState({ message: value });
        this.setState({ disabled: value ? false : true });
    }
    /**
     * Appends a selected smileys to the chat message draft.
     *
     * @param {string} smileyText - The value of the smiley to append to the
     * chat message.
     * @private
     * @returns {void}
     */
    _onSmileySelect(smileyText) {
        if (smileyText) {
            this.setState({
                message: `${this.state.message} ${smileyText}`,
                showSmileysPanel: false
            });
        }
        else {
            this.setState({
                showSmileysPanel: false
            });
        }
        this._focus();
    }
    /**
     * Callback invoked to hide or show the smileys selector.
     *
     * @private
     * @returns {void}
     */
    _toggleSmileysPanel() {
        if (this.state.showSmileysPanel) {
            this._focus();
        }
        this.setState({ showSmileysPanel: !this.state.showSmileysPanel });
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @private
 * @returns {{
 *     _areSmileysDisabled: boolean
 * }}
 */
const mapStateToProps = (state) => {
    return {
        _areSmileysDisabled: areSmileysDisabled(state)
    };
};
export default translate(connect(mapStateToProps)(ChatInput));
